export default __webpack_public_path__ + "static/workshops-4e6bc558d7215f3b935a34fe533724be.png";